<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Attribut</mat-label>
            <mat-select formControlName="attribute" required tabindex="1" (selectionChange)="onSelectedAttributeChange($event)">
                <mat-option *ngFor="let attribute of _attributes" [value]="attribute.id">
                    {{ attribute.header }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="dataForm.controls['attribute']?.errors?.required && (dataForm.controls['attribute']?.dirty || dataForm.controls['attribute'].touched)">
                Le champ 'Attribut' est obligatoire
            </mat-error>
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO État" matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Type de comparaison</mat-label>
            <mat-select formControlName="comparisonType" required tabindex="2">
                <mat-option [value]="ComparisonType.Equal">Egale à</mat-option>
                <mat-option [value]="ComparisonType.NotEqual">Différent de</mat-option>
                @if (
                    selectedAttribute &&
                    (selectedAttribute.type === PropertyType.Date ||
                        selectedAttribute.type === PropertyType.DateAndTime ||
                        selectedAttribute.type === PropertyType.Decimal ||
                        selectedAttribute.type === PropertyType.Long)
                ) {
                    <mat-option [value]="ComparisonType.LessThan">Inférieur à</mat-option>
                    <mat-option [value]="ComparisonType.LessOrEqual">Inférieur ou égale à</mat-option>
                    <mat-option [value]="ComparisonType.GreaterThan">Supérieur à</mat-option>
                    <mat-option [value]="ComparisonType.GreaterOrEqual">Supérieur ou égale à</mat-option>
                }
            </mat-select>
            <mat-error *ngIf="dataForm.controls['comparisonType']?.errors?.required && (dataForm.controls['comparisonType']?.dirty || dataForm.controls['comparisonType'].touched)">
                Le champ 'Type de comparaison' est obligatoire
            </mat-error>
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO État" matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help" *ngIf="selectedAttribute">
        <ng-container *ngIf="mode !== FormMode.Reading">
            <!-- Affichage d'un attribut de type 'Texte' -->
            <ng-container
                *ngIf="
                    selectedAttribute.type !== PropertyType.Long &&
                    selectedAttribute.type !== PropertyType.Decimal &&
                    selectedAttribute.type !== PropertyType.Date &&
                    selectedAttribute.type !== PropertyType.DateAndTime &&
                    selectedAttribute.type !== PropertyType.List &&
                    selectedAttribute.type !== PropertyType.ListCustomers &&
                    selectedAttribute.type !== PropertyType.Color &&
                    selectedAttribute.type !== PropertyType.AutocompletionByApi &&
                    selectedAttribute.type !== PropertyType.ListUsers
                ">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="text" formControlName="comparaisonValue" autocomplete="off" required />
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                    <mat-error *ngIf="dataForm.controls['comparaisonValue']?.hasError('pattern')">
                        <span title="Le champ doit respecter l'expression régulière : {{ selectedAttribute.format }}.">
                            Le champ doit respecter l'expression régulière : {{ selectedAttribute.format }}.
                        </span>
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Entier' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.Long">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="number" formControlName="comparaisonValue" autocomplete="off" required />
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                    <mat-error *ngIf="dataForm.controls['comparaisonValue']?.hasError('invalidError')">
                        <span title="La valeur n'est pas un nombre entier valide.">La valeur n'est pas un nombre entier valide.</span>
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Decimal' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.Decimal">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="number" formControlName="comparaisonValue" autocomplete="off" required />
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                    <mat-error *ngIf="dataForm.controls['comparaisonValue']?.hasError('invalidError')">
                        <span title="La valeur n'est pas un nombre décimal valide.">La valeur n'est pas un nombre décimal valide.</span>
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Date' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.Date">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput [matDatepicker]="datepicker" formControlName="comparaisonValue" required />
                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Date & heure' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.DateAndTime">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput [ngxMatDatetimePicker]="picker" formControlName="comparaisonValue" required />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #picker></ngx-mat-datetime-picker>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Liste' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.List && selectedAttribute.custom === true">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="comparaisonValue" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let attributeValue of selectedAttribute.attributeValueDefinitions" [value]="attributeValue.id.toString()">
                            {{ attributeValue.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Client' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.ListCustomers">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="comparaisonValue" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let attributeValue of selectedAttribute.attributeValueDefinitions" [value]="attributeValue.id.toString()">
                            {{ attributeValue.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage de l'attribut 'Etat' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.List && selectedAttribute.name === 'FolderStateId'">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="comparaisonValue" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let state of _folderStates" [value]="state.id.toString()">{{ state.name }}</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage de l'attribut de type 'Utilisateur' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.ListUsers">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="comparaisonValue" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let user of _users" [value]="user.id.toString()">{{ user.displayName }}</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Couleur' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.Color">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="comparaisonValue" ngClass="bak-{{ dataForm.get('comparaisonValue').value }}-color" required>
                        <mat-option value="">Aucune</mat-option>
                        <mat-option class="mat-option-green-color" value="Green"></mat-option>
                        <mat-option class="mat-option-orange-color" value="Orange"></mat-option>
                        <mat-option class="mat-option-red-color" value="Red"></mat-option>
                        <mat-option class="mat-option-grey-color" value="Grey"></mat-option>
                        <mat-option class="mat-option-light-blue-color" value="LightBlue"></mat-option>
                        <mat-option class="mat-option-dark-blue-color" value="DarkBlue"></mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Autocompletion par API' -->
            <ng-container *ngIf="selectedAttribute.type === PropertyType.AutocompletionByApi">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="text" formControlName="comparaisonValue" [matAutocomplete]="auto" />
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (closed)="onAutocompleteClosed()" (optionSelected)="onAutocompleteItemSelected($event)">
                        <mat-option *ngFor="let autocompletionValue of autocompletionValues | async" [value]="autocompletionValue">{{ autocompletionValue }}</mat-option>
                    </mat-autocomplete>
                    <mat-error
                        *ngIf="
                            dataForm.controls['comparaisonValue']?.errors?.required &&
                            (dataForm.controls['comparaisonValue']?.dirty || dataForm.controls['comparaisonValue'].touched)
                        ">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="mode === FormMode.Reading">
            <!-- Non géré -->
        </ng-container>

        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Valeur" matTooltipPosition="right"></fa-icon>
    </div>
</form>
